import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map } from 'rxjs';
import { MblogResponse } from 'src/app/pages/blog/blog.module';
import { MBlogFilterRequest, MCommonBlogListModalRequest, MCommonListModalRequest, UtilsService } from 'src/app/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class WsBlogService {

  constructor(private httpClient: HttpClient) { }


  /**
  * Api to Blog List
  * @returns 
  */
  getBlogList(mCommonListModalRequest: MCommonListModalRequest): Observable<MblogResponse> {
    var jsonBody = JSON.stringify(mCommonListModalRequest);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MblogResponse>(UtilsService.BASE_URL + UtilsService.BLOGLIST, jsonBody, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }


  getCategoryList(mCommonListModalRequest: MCommonListModalRequest): Observable<any> {
    var jsonBody = JSON.stringify(mCommonListModalRequest);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<any>(UtilsService.BASE_URL + UtilsService.GETALLCATEGORY, jsonBody, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  /**
  * Api to Blog List By category id
  * @returns 
  */
  getBlogListByCategory(mCommonListModalRequest: MCommonListModalRequest): Observable<MblogResponse> {
    var jsonBody = JSON.stringify(mCommonListModalRequest);
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MblogResponse>(UtilsService.BASE_URL + UtilsService.BLOGLISTBYCATEGORYID, jsonBody, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  /**
  * Api to Blog List By category id Filter
  * @returns 
  */
  getBlogListByCategoryFilter(mCommonListModalRequest: MBlogFilterRequest): Observable<MblogResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.post<MblogResponse>(UtilsService.BASE_URL + UtilsService.GetAllBlogFilter+'?skip='+mCommonListModalRequest.skip+'&take='+mCommonListModalRequest.take+'&catagoryid='+mCommonListModalRequest.catagoryid, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }

  
  /**
  * Api to Blog List By category id
  * @returns 
  */
  getAllBlogFilter(mCommonBlogListModalRequest: MCommonBlogListModalRequest): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    var url = UtilsService.BASE_URL + UtilsService.GetAllBlogFilter+'?skip=' + mCommonBlogListModalRequest.skip + '&take=' + mCommonBlogListModalRequest.take;
    if(mCommonBlogListModalRequest.catagoryid){
      url = UtilsService.BASE_URL + UtilsService.GetAllBlogFilter+'?skip=' + mCommonBlogListModalRequest.skip + '&take=' + mCommonBlogListModalRequest.take + '&catagoryid=' + mCommonBlogListModalRequest.catagoryid;
    }
    if(mCommonBlogListModalRequest.subcategoryid){
      url = UtilsService.BASE_URL + UtilsService.GetAllBlogFilter+'?skip=' + mCommonBlogListModalRequest.skip + '&take=' + mCommonBlogListModalRequest.take + '&catagoryid=' + mCommonBlogListModalRequest.catagoryid + '&subcategoryid='+ mCommonBlogListModalRequest.subcategoryid;
    }
    return this.httpClient.post<any>(url, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }


  getBlogCataoryWiseWithAllFilter(isTranding?:any, isEditorsPick?:any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    var url = UtilsService.BASE_URL + UtilsService.GetBlogCataoryWiseWithAllFilter;
    if(isTranding){
      url = UtilsService.BASE_URL + UtilsService.GetBlogCataoryWiseWithAllFilter+'?is_tranding=' + isTranding;
    }
    if(isEditorsPick){
      url = UtilsService.BASE_URL + UtilsService.GetBlogCataoryWiseWithAllFilter+'?editors_pick=' + isEditorsPick;
    }
    return this.httpClient.post<any>(url, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }
  /**
 * Api to categoryList by TypeID
 * @returns 
 */
  getCategoryByType(typeId: any): Observable<MblogResponse> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
    return this.httpClient.get<MblogResponse>(UtilsService.BASE_URL + UtilsService.CATEGORYBYTYPEID + '?typeId=' + typeId, httpOptions)
      .pipe(
        map(response => {
          return response;
        }), catchError(UtilsService.ErrorHandler.handleError('getData'))
      )
  }
}
